export const SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS = 'SET_CONVOCATION_RESIGNATIONS_ACADEMIC_PROGRAMS';
